import React, { useState, useEffect, useCallback } from 'react';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useDataProvider, useTranslate } from 'react-admin';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  autocomplete: {
    width: 300,
  },
}));

const basicOptions = (orderField) => buildOptions(orderField, orderField, "");

const buildOptions = (orderField, filterField, filterValue) => {
  return {
    pagination: { page: 1, perPage: 100 },
    sort: { field: orderField, order: "ASC" },
    filter: { [filterField]: filterValue },
  };
};

const ParamAutocompleteInput = ({
  optionValue = "id",
  optionText = "descripcion",
  resource,
  onChange = (value) =>
    console.warn("Define onChange param to handle select changes", value),
}) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const handleChange = (event, newValue) => {
    console.log("newValue", newValue);
    onChange(newValue && newValue[optionValue]);
  };

  const handleInputChange = (event, newInputValue) => {
    updateState(buildOptions(optionText, optionText, newInputValue));
  };

  const updateState = useCallback(
    (listOptions) => {
      dataProvider
        .getList(resource, listOptions)
        .then(({ data }) => {
          setList(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    },
    [dataProvider, resource]
  );

  useEffect(() => {
    const listOptions = basicOptions(optionText);
    updateState(listOptions);
  }, [resource, optionText, dataProvider, updateState]);

  if (loading) {
    return <LinearProgress />;
  }
  if (error) {
    return <pre>{JSON.stringify(error)}</pre>;
  }

  return (
    <FormControl className={classes.formControl}>
      <Autocomplete
        options={list}
        getOptionSelected={(option, value) =>
          option[optionValue] === value[optionValue]
        }
        getOptionLabel={(option) => option[optionText]}
        className={classes.autocomplete}
        onChange={handleChange}
        onInputChange={handleInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={translate(`resources.${resource}.name`, 1)}
          />
        )}
      />
    </FormControl>
  );
};

export default ParamAutocompleteInput;
